import { render, staticRenderFns } from "./ExtruderCharts.vue?vue&type=template&id=7064228d&scoped=true"
import script from "./ExtruderCharts.vue?vue&type=script&lang=js"
export * from "./ExtruderCharts.vue?vue&type=script&lang=js"
import style0 from "./ExtruderCharts.vue?vue&type=style&index=0&id=7064228d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7064228d",
  null
  
)

export default component.exports